import interact from 'interactjs';

export default {
    data: function () {
        return {
            startLeft: 0,
            startTop: 0,
            startWidth: 0,
            startHeight: 0,
            prevWidth: 0,
            prevHeight: 0,
            snapDistance: 5,
            resizable: true,
            movable: true,
            preserveAspectRatio: false,
            locked: false,
            interactjs: undefined
        }
    },
    methods: {
        computeNewLeft: function (newPosition, newSize, prevSize, event, snapDistance, x) {
            newPosition['left'] = x;
            if (event.edges.left) {
                newPosition['left'] -= (newSize['width'] - prevSize['width']);
            } else if ((event.edges.top && !event.edges.right) || (event.edges.bottom && !event.edges.right)) {
                newPosition['left'] -= (newSize['width'] - prevSize['width']) / 2;
                snapDistance = 0;
            }
            newPosition['left'] = (newPosition['left'] < snapDistance) ? 0 : newPosition['left'];
        },
        computeNewTop: function (newPosition, newSize, prevSize, event, snapDistance, y) {
            newPosition['top'] = y;
            if (event.edges.top) {
                newPosition['top'] -= (newSize['height'] - prevSize['height']);
            } else if ((event.edges.left && !event.edges.bottom) || (event.edges.right && !event.edges.bottom)) {
                newPosition['top'] -= (newSize['height'] - prevSize['height']) / 2;
                snapDistance = 0;
            }
            newPosition['top'] = (newPosition['top'] < snapDistance) ? 0 : newPosition['top'];
        },
        computeNewPosition: function (newPosition, newSize, prevSize, event, snapDistance, x, y) {
            //newPosition is by reference, as it is an object.
            this.computeNewLeft(newPosition, newSize, prevSize, event, snapDistance, x);
            this.computeNewTop(newPosition, newSize, prevSize, event, snapDistance, y);

        },
        computeNewSize: function (newSize, event) {
            let diffY = event.pageY - event.y0;
            let diffX = event.pageX - event.x0;

            if (event.edges.top) {
                newSize['height'] -= diffY;
            } else if (event.edges.bottom) {
                newSize['height'] += diffY;
            }
            if (event.edges.left) {
                newSize['width'] -= diffX;
            } else if (event.edges.right) {
                newSize['width'] += diffX;
            }
        },
        aspectRatio: function (newSize, event, prevSize, info) {
            let oldRatio = prevSize['width'] / prevSize['height'];
            let diffY = event.pageY - event.y0;
            let diffX = event.pageX - event.x0;

            if (this.preserveAspectRatio) {
                if(info === 'onlySmaller') {
                    if(newSize['height'] > newSize['width'] / oldRatio) {
                        newSize['height'] = newSize['width'] / oldRatio;
                    } else {
                        newSize['width'] = newSize['height'] * oldRatio;
                    }
                } else if (((event.edges.left || event.edges.right) && (!event.edges.top && !event.edges.bottom)) || info === 'fixedWidth') {
                    newSize['height'] = newSize['width'] / oldRatio;
                } else if ((!event.edges.left && !event.edges.right) || info === 'fixedHeight') {
                    newSize['width'] = newSize['height'] * oldRatio;
                } else {
                    var helper = (newSize['height'] * oldRatio + newSize['width']) / 2;
                    newSize['height'] = (newSize['width']/ oldRatio + newSize['height']) / 2;
                    newSize['width'] = helper;
                }
            }
        },
        dragStartListener: function (event) {
            if (this.data.locked) return null;

            let target = event.target;
            this.startLeft = parseFloat(target.getAttribute('data-x')) || 0;
            this.startTop = parseFloat(target.getAttribute('data-y')) || 0;
        },
        dragMoveListener: function (event) {
            if (this.data.locked) return null;

            let target = event.target,
                // keep the dragged position in the data-x/data-y attributes
                x = this.startLeft + (event.pageX - event.x0),
                y = this.startTop + (event.pageY - event.y0);

            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

            // update the position attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);

            EaseEventBus.fire('elementMoved', {
                id: this.index,
                x: x,
                y: y
            });
        },
        dragEndListener() {
            EaseEventBus.fire('elementMovedEnd', {
                id: this.index
            });
        },
        /** 'move' function doesn't seem to ever get called, useless code */
        move: function (step, keyEvent) {
            if (this.data.locked) return null;

            if(this.movable) {
                if(keyEvent === "down") {
                    let x = parseFloat(this.$el.getAttribute('data-x')) + step[0];
                    let y = parseFloat(this.$el.getAttribute('data-y')) + step[1];

                    let width = parseFloat(this.$el.style.width);
                    let height = parseFloat(this.$el.style.height);

                    x = Math.max(0, Math.min(this.frame.width - width, x));
                    y = Math.max(0, Math.min(this.frame.height - height, y));

                    this.$el.setAttribute('data-x', x);
                    this.$el.setAttribute('data-y', y);
                    this.$el.style.webkitTransform = this.$el.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
                } else if(keyEvent === "up") {
                    this.dragEndListener();
                }
            }
        },
        resize: function (step, keyEvent) {
            if (this.data.locked) return null;

            if(this.resizable) {
                if(keyEvent === "down") {
                    let origX = parseFloat(this.$el.getAttribute('data-x'));
                    let origY = parseFloat(this.$el.getAttribute('data-y'));

                    let origWidth = parseFloat(this.$el.style.width);
                    let origHeight = parseFloat(this.$el.style.height);

                    let x = origX;
                    let y = origY;
                    let width = origWidth + step[0];
                    let height = origHeight + step[1];

                    width = Math.max(this.hasMinWidth(), Math.min(this.frame.width, width));
                    height = Math.max(this.hasMinHeight(), Math.min(this.frame.height, height));

                    if (x + width > this.frame.width) {
                        x = Math.max(0, Math.min(this.frame.width - width, x));

                        if (x + width > this.frame.width) {
                            width = this.frame.width - x;
                        }
                    }
                    if(y + height > this.frame.height) {
                        y = Math.max(0, Math.min(this.frame.height - height, y));
                        if (y + height > this.frame.height) {
                            height = this.frame.height - y;
                        }
                    }

                    this.$el.setAttribute('data-x', x);
                    this.$el.setAttribute('data-y', y);

                    this.$el.style.width = width + 'px';
                    this.$el.style.height = height + 'px';
                    this.$el.style.webkitTransform = this.$el.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
                } else if(keyEvent === "up") {
                    this.resizeEnd();
                }
            }
        },
        resizeStart: function (event) {
            if (this.data.locked) return null;

            let target = event.target;
            this.startLeft = (parseFloat(target.getAttribute('data-x')) || 0);
            this.startTop = (parseFloat(target.getAttribute('data-y')) || 0);
            this.startWidth = event.target.offsetWidth;
            this.startHeight = event.target.offsetHeight;
            this.prevWidth = event.target.offsetWidth;
            this.prevHeight = event.target.offsetHeight;
        },
        resizeMove: function (event) {
            if (this.data.locked) return null;

            let target = event.target,
                x = (parseFloat(target.getAttribute('data-x')) || 0),
                y = (parseFloat(target.getAttribute('data-y')) || 0);

            // Don't resize outside of the left side
            if (x < 0) {
                target.setAttribute('data-x', 0);
            }

            // Don't resize outside of the top side
            if (y < 0) {
                target.setAttribute('data-y', 0);
            }

            // Keep aspect if original
            let prevSize = {'width': this.prevWidth, 'height': this.prevHeight};
            let newSize = {'width': this.startWidth, 'height': this.startHeight};

            this.computeNewSize(newSize, event);
            this.aspectRatio(newSize, event, prevSize);

            let changeWidth = true;
            let changeHeight = true;
            let changeLeft = true;
            let changeTop = true;

            let newPosition = {'left': 0, 'top': 0};
            this.computeNewPosition(newPosition, newSize, prevSize, event, this.snapDistance, x, y);

            let maxWidth = this.frame.width - newPosition['left'];
            let maxHeight = this.frame.height - newPosition['top'];
            newSize['width'] = Math.min(newSize['width'], maxWidth);
            newSize['height'] = Math.min(newSize['height'], maxHeight);

            if (newPosition['left'] === 0 && event.edges.left) {
                newSize['width'] = this.startLeft + this.startWidth; // changeWidth = false; //if element already on left side, dont change width anymore
                this.aspectRatio(newSize, event, prevSize);
                this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
                this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);
            }
            if (newPosition['top'] === 0 && event.edges.top) {
                newSize['height'] = this.startTop + this.startHeight; //if element already at top border, dont change height anymore
                this.aspectRatio(newSize, event, prevSize);
                this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);
                this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
            }

            let snapDistance = 0.01;
            if (event.edges.left || event.edges.right) {
                snapDistance += this.snapDistance;
            }
            if (newSize['width'] >= maxWidth - snapDistance) {
                newSize['width'] = maxWidth;
                this.aspectRatio(newSize, event, prevSize, 'fixedWidth');
                this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
                this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);
            }

            snapDistance = 0.01;
            if (event.edges.top || event.edges.bottom) {
                snapDistance += this.snapDistance;
            }
            if (newSize['height'] >= maxHeight - snapDistance) {
                newSize['height'] = maxHeight;
                this.aspectRatio(newSize, event, prevSize, 'fixedHeight');
                this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);
                this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
            }

            // Don't resize outside of the right/bottom side
            newSize['width'] = Math.min(newSize['width'], this.frame.width - newPosition['left']);
            newSize['height'] = Math.min(newSize['height'], this.frame.height - newPosition['top']);
            this.aspectRatio(newSize, event, prevSize, 'onlySmaller');
            this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
            this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);

            // Force minimal size
            if (newSize['width'] * this.frame.ratio < this.hasMinWidth()) {
                newSize['width'] = this.hasMinWidth() / this.frame.ratio;
                this.aspectRatio(newSize, event, prevSize, 'fixedWidth');
                this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
                this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);
            }

            if (newSize['height'] * this.frame.ratio < this.hasMinHeight()) {
                newSize['height'] = this.hasMinHeight() / this.frame.ratio;
                this.aspectRatio(newSize, event, prevSize, 'fixedHeight');
                this.computeNewTop(newPosition, newSize, prevSize, event, this.snapDistance, y);
                this.computeNewLeft(newPosition, newSize, prevSize, event, this.snapDistance, x);
            }

            if (changeLeft) x = newPosition['left'];
            if (changeTop) y = newPosition['top'];

            if (changeWidth) {
                this.buttonsOutsideDueToWidth = newSize.width < this.actionButtonsWidth;
                target.style.width = newSize['width'] + 'px';
                this.prevWidth = newSize['width'];
            }
            if (changeHeight) {
                this.buttonsOutsideDueToHeight = newSize.height < this.actionButtonsHeight;
                target.style.height = newSize['height'] + 'px';
                this.prevHeight = newSize['height'];
            }
            target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);

            EaseEventBus.fire('elementMoved', {
                id: this.index,
                x: x,
                y: y
            });
            EaseEventBus.fire('elementResized', {
                id: this.index,
                width: newSize['width'],
                height: newSize['height']
            });
        },
        resizeEnd: function (event) {
            this.tap();
            this.dragEndListener();
            EaseEventBus.fire('elementResizedEnd', {
                id: this.index
            });
        },
        mountedIsResizable: function (locked=null) {
            this.$nextTick(() => {
                let readonly = this.$el.getAttribute('data-readonly') === '1';
                if(locked == null) {
                    locked = this.$el.getAttribute('data-locked') === '1' || this.locked;
                } else {
                    this.$el.setAttribute('data-locked', locked ? '1' : '0');
                }

                if (readonly !== true && locked !== true && !this.basicPrivilege) {
                    if (typeof this.interactjs === 'undefined') {
                        this.interactjs = interact(this.$el);

                        this.interactjs.draggable({
                            onstart: this.dragStartListener,
                            onmove: this.dragMoveListener,
                            onend: this.dragEndListener,
                            restrict: {
                                restriction: 'parent',
                                elementRect: {top: 0, left: 0, bottom: 1, right: 1}
                            },
                        });
                        this.interactjs.resizable({
                            edges: {left: true, right: true, bottom: true, top: true},
                            restrictEdges: {outer: 'parent', endOnly: true}
                        }).on('resizestart', this.resizeStart).on('resizemove', this.resizeMove).on('resizeend', this.resizeEnd);

                    } else {
                        this.interactjs.draggable(true);
                        this.interactjs.resizable(true);
                    }
                    this.resizable = true;
                    this.movable = true;
                } else {
                    if (typeof this.interactjs !== 'undefined') {
                        this.interactjs.draggable(false);
                        this.interactjs.resizable(false);
                        this.resizable = false;
                        this.movable = false;
                    }
                }
            });
        }
    },
    mounted: function () {
        if(this.data.type !== 'background') {
            EaseEventBus.listen('element.' + this.index + '.move', (data) => {
                console.log('move', data);
                this.move(data[0], data[1]);
            });
            EaseEventBus.listen('element.' + this.index + '.resize', (data) => {
                console.log('resize', data);
                this.resize(data[0], data[1]);
            });
            EaseEventBus.listen('element.' + this.index + '.temporaryAspectRatio', (temporary_locked_ratio) => {
                this.preserveAspectRatio = this.locked_ratio || temporary_locked_ratio;
            });
        }
    },
    watch: {
        interactive(val) {
            if(this.data.type == 'background') {
                return;
            }

            if (val) {
                this.mountedIsResizable();
            } else {
                this.interactjs?.draggable(false);
                this.interactjs?.resizable(false);
                this.resizable = false;
                this.movable = false;
            }
        }
    }
};
